import { AnimatePresence, motion } from 'framer-motion'
import MD5 from 'md5'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { AiOutlineCheck } from 'react-icons/ai'
import { useQuery } from 'react-query'
import { useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { getClassInfo, getUserInfo } from '@/api/center'
import { getSalesInfo, popupAddQweChat } from '@/api/login'
import UserAvatarImg from '@/assets/images/defaultUserAvatar.png'
import eqcodeImg from '@/assets/images/eqcode.png'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Modal from '@/components/Modal'
import { centerStore, globalStore, useRecoilState, useSetRecoilState } from '@/store'

const { addProWxWinState, proWxWinEqState } = globalStore
const { userState } = centerStore

export default function Index() {
  const navigate = useNavigate()
  const [classNum, setClassNum] = useState<any>({})
  const [modalState, setModalState] = useState<boolean>(false)
  const [multiple, setMultiple] = useState<any[]>([])
  const [user, setUser] = useRecoilState(userState)
  const setAddProWxWin = useSetRecoilState(addProWxWinState)
  const setProWxWinEq = useSetRecoilState(proWxWinEqState)
  const queryClient = useQueryClient()

  const { isLoading, data } = useQuery(['getUserInfo'], () => {
    const timestamp = (Date.now() / 1000).toFixed(0)
    return getUserInfo({
      userId: localStorage.userid,
      sign: MD5(`userId=${localStorage.userid}&timestamp=${timestamp}&key=${import.meta.env.VITE_APP_userSecretKey}`),
      uniqueDeviceNo: localStorage.visitorId,
      timestamp
    })
  })

  useEffect(() => {
    if (data && data.status === 0) {
      const { childs, ...other } = data.data
      const user = {
        ...other,
        id: other.uid,
        avatar: other.head,
        gender: other.sex
      }
      setMultiple(childs || [user])
      const userId = localStorage.userid
      setUser((childs || []).find((item: any) => item.id === Number(userId)) || user)
    }
  }, [data])

  const qweChat = useQuery(['popupAddQweChat', user.id], (props) => {
    console.log('popupAddQweChat', user)
    if (props.queryKey[1]) {
      return popupAddQweChat()
    }
  })

  useEffect(() => {
    const { data } = qweChat
    if (data && data.status === 0) {
      const {
        data: { sales, status }
      } = data
      if (status === 2) {
        getSalesInfo({ adminId: sales, uid: user.id }).then((data: any) => {
          if (data.code === 0) {
            setProWxWinEq(data.payload)
          } else {
            setProWxWinEq(eqcodeImg)
          }
          setAddProWxWin(true)
        })
      }
    }
  }, [qweChat.data])

  const changeUser = (data: any) => {
    setModalState(false)
    toast.success('切换成功')
    queryClient.clear()
    setUser(data)
    const { avatar, username, id, isVip } = data
    localStorage.setItem('head', avatar)
    localStorage.setItem('username', username)
    localStorage.setItem('userid', id)
    const usersStore = localStorage.getItem('__myk_users__')
    const mykUsers = usersStore ? JSON.parse(usersStore) : null
    if (mykUsers) {
      const users = mykUsers.find((item: { id: any }) => String(item.id) === String(id))
      if (users) {
        localStorage.setItem('token', users.token)
      }
    }
    localStorage.setItem('isVip', isVip ? '1' : '0')
  }

  const classInfo = useQuery(['getClassInfo', user.id], (props) => {
    const timestamp = (Date.now() / 1000).toFixed(0)
    if (props.queryKey[1]) {
      return getClassInfo({
        userId: props.queryKey[1],
        sign: MD5(`userId=${props.queryKey[1]}&timestamp=${timestamp}&key=${import.meta.env.VITE_APP_userSecretKey}`),
        timestamp
      })
    }
  })

  useEffect(() => {
    if (classInfo.data && classInfo.data.status === 0) {
      setClassNum(classInfo.data.data)
    }
  }, [classInfo.data])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="flex justify-center items-center relative">
      <Loadding state={isLoading}>
        <div className="flex justify-start items-center flex-1">
          <div className="w-[52px] h-[52px] rounded-full">
            <ImgPlaceholder className="w-full h-full rounded-full" src={user.avatar} alt="UserAvatar" />
          </div>
          <div className="ml-[15px]">
            <div className="text-[18px] text-[#333] flex items-center">
              {user.username}
              {multiple.length > 1 ? (
                <button onClick={() => setModalState(true)} className="ml-[20px] btn-style rounded-full px-[10px] py-[2px] text-[14px] text-[#FFF] anim_btn2">
                  切换宝宝
                </button>
              ) : null}
            </div>
            <div className="text-[14px] text-[#999]">
              {user.gender === 2 ? '女' : '男'}&ensp;|&ensp;{user.age}岁
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center">
          <div className="mr-[20px] text-center">
            <div className="text-[24px] text-[#000] font-semibold">{classNum.masterTime}</div>
            <div className="text-[14px] text-[#666]">剩余主修课</div>
          </div>
          <div className="mr-[20px] text-center">
            <div className="text-[24px] text-[#000] font-semibold">{classNum.commonTime}</div>
            <div className="text-[14px] text-[#666]">剩余公开课</div>
          </div>
          <div className="mr-[20px] text-center">
            <div className="text-[24px] text-[#000] font-semibold">{classNum.useTime}</div>
            <div className="text-[14px] text-[#666]">已上课时</div>
          </div>
        </div>
      </Loadding>
      <Modal show={modalState} cancel={() => setModalState(false)} title="切换宝宝" className="class-modal">
        <div className="flex items-center justify-evenly my-[20px]">
          {multiple.map((item, i) => (
            <div key={i} className="flex items-center flex-col">
              <div onClick={() => changeUser(item)} className={`${user.id === item.id ? 'select' : ''} avatar w-[52px] h-[52px] rounded-full mb-[10px] cursor-pointer relative`}>
                <ImgPlaceholder className="w-full h-full rounded-full" src={item.avatar} alt="UserAvatar" />
              </div>
              <div>{item.username}</div>
            </div>
          ))}
        </div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 30px;
  background-color: #fff;
  border-radius: 6px;
  .avatar {
    border: 2px solid #ffffff;
    &:hover {
      border: 2px solid #ff3300;
    }
  }
  .select {
    border: 2px solid #ff3300;
  }
  .btn-style {
    background: linear-gradient(39deg, #ff742f 0%, #ff3300 100%);
    box-shadow:
      rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  }
`
